<template>
    <div
        class="business-rule-select"
        :class="{ 'only-one-rule': onlyOneRule }"
    >
        <rule-generator
            ref="rules"
            :rule-options="ruleOptions"
            :default="ruleInfo"
            :rule-selected-val="ruleSelectedVal"
            @change="onRuleChange"
        />
        <!-- <v-button @click="validate">验证</v-button> -->
    </div>
</template>

<script>
import RuleGenerator from '@/components/rule-generator';

export default {
  components: {
    RuleGenerator,
  },

  props: {
    ruleOptions: {
      type: Array,
      default: () => [],
    },

    ruleInfo: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      currRuleSelectedVal: '',
      ruleSelectedVal: '',
    };
  },

  computed: {
    // 只有一个规则
    onlyOneRule() {
      return this.ruleOptions && this.ruleOptions.length === 1;
    },
  },

  watch: {
    ruleOptions() {},
    ruleInfo() {},
  },

  created() {
    this.$nextTick(() => {
      if (this.onlyOneRule) {
        this.ruleSelectedVal = this.ruleOptions[0] && this.ruleOptions[0].value;
      }
    });
  },

  methods: {
    validate() {
      return this.$refs.rules.validate();
    },

    onRuleChange(ruleInfo) {
      // const { showData } = ruleInfo || {};
      this.$emit('change', ruleInfo);
    },
  },
};
</script>
<style lang="less">
@import './index.less';
</style>
